import { media } from 'responsive/media';
import styled, { css } from 'styled-components';

export const CourseScheduleWrapper = styled.div``;

export const ModalCourseScheduleWrapper = styled.div`
  width: 100% !important;

  .ant-input-number {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 0 !important;
  }

  .ant-typography {
    color: inherit !important;
  }

  .ant-picker-input {
    width: 134px !important;
  }
  .ant-picker.ant-picker-outlined {
    width: 353px !important;
  }
`;

export const ModalCourseDetailWrapper = styled.div`
  width: 100%;
  height: max-content;
  overflow-y: auto;
  .ant-table-wrapper {
    overflow-y: auto !important;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  padding-left: ${({ $paddingMessage }) => $paddingMessage}px;

  ${media.xlDown(css`
    padding-left: 115px;
  `)}

  ${media.xxlDown(css`
    padding-left: 115px;
  `)}

  ${media.lgDown(css`
    padding-left: 80px;
  `)}
`;
